(function() {
    'use strict';

    angular.module( APP_ID )
        .directive( 'scrollToAnchor', [ 'AutoscrollService', scrollToAnchorDirective ] );


    /**
     * Enhances clickable element to scroll to
     * a specific anchor (~ another element with an ID).
     *
     * @param {AutoscrollService} AutoscrollService
     *
     * @type {ng.IDirectiveCompileFn}
     */
    function scrollToAnchorDirective( AutoscrollService ){


        /** @type {ng.IDirective} */
        var directiveConfig = {
            scope:       {},
            restrict:    'A',
            link:        link
        };



        ////////////////////////////////////////////////////////////////////////

        return directiveConfig;

        ////////////////////////////////////////////////////////////////////////



        /**
         * @param {ng.IScope} $scope
         * @param {ng.IElement} $element
         * @param {ng.IAttributes} $attributes
         */
        function link( $scope, $element, $attributes ) {


            /** Members */
            var anchorId;


            /* ===== RUN ON INSTANTIATION =================================== */


            /** @constructor */
            (function init(){
                if ( $attributes.hasOwnProperty( 'scrollToAnchor' ) && $attributes.scrollToAnchor ) {
                    anchorId = $attributes.scrollToAnchor;
                }

                $element.bind( 'click', scrollToBlock );
            })();


            /** Private functions */

            function scrollToBlock( $event ){
                $event.preventDefault();
                AutoscrollService.scrollToElementById( anchorId );

                return true;
            }

        }


    }
})();
